import React from 'react';
import { LifeBuoy } from 'lucide-react';

const DrillsSummaryCard = ({ complianceStats }) => {
  const overdueCount = complianceStats.overdue || 0;
  const dueSoonCount = complianceStats.dueSoon || 0;
  const compliantCount = complianceStats.compliant || 0;
  const totalCount = overdueCount + dueSoonCount + compliantCount;
  const compliancePercentage = complianceStats.compliancePercentage || 0;

  return (
    <div className="rounded-2xl border border-gray-200 shadow-sm bg-white overflow-hidden">
      {/* Header */}
      <div className="bg-slate-700 px-5 py-3">
        <div className="flex items-center gap-2">
          <LifeBuoy className="h-5 w-5 text-white" />
          <h3 className="text-base font-semibold text-white">Drill Summary</h3>
        </div>
      </div>

      <div className="px-6 py-5">
        {/* Compliance Bar */}
        <div className="mb-4">
          <div className="flex items-center justify-between mb-1">
            <span className="text-sm text-gray-600">Overall Compliance</span>
            <span className="text-sm font-semibold text-gray-900">{compliancePercentage}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className={`h-2 rounded-full transition-all duration-300 ${
                compliancePercentage >= 90 ? 'bg-green-600' :
                compliancePercentage >= 70 ? 'bg-amber-500' : 'bg-red-600'
              }`}
              style={{ width: `${compliancePercentage}%` }}
            />
          </div>
        </div>

        {/* Status Counts */}
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-red-500 rounded-full"></div>
              <span className="text-sm text-gray-600">Overdue</span>
            </div>
            <span className="text-sm font-semibold text-red-600">{overdueCount}</span>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
              <span className="text-sm text-gray-600">Due Soon</span>
            </div>
            <span className="text-sm font-semibold text-amber-600">{dueSoonCount}</span>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span className="text-sm text-gray-600">Compliant</span>
            </div>
            <span className="text-sm font-semibold text-green-600">{compliantCount}</span>
          </div>
        </div>

        {/* Total */}
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">Total</span>
            <span className="text-sm font-semibold text-gray-900">{totalCount} drills</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrillsSummaryCard;
